import type { TProjectTemplateMock } from './types';

export const isTemplateProject = (templates: TProjectTemplateMock[] | undefined, projectId: string): boolean =>
  !!templates?.some(({ project }) => project === projectId);
